
import { namespace } from 'vuex-class'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Member } from '@/types/Member.type'
import { HeaderSwitcherItem } from '@/types/Header.type'
import RouteName from '@/utils/RouteName'
import ClickOutside from 'vue-click-outside'

const User = namespace('user')
@Component({
    directives: {
        ClickOutside,
    },
})
export default class HeaderSwitcher extends Vue {
    @User.State me!: Member
    RouteName = RouteName
    switcherJoined: HeaderSwitcherItem[] = []
    switcherDiscover: HeaderSwitcherItem[] = []
    showDropdown = false

    FRENCHFOUNDERS_SPA_2_URL = process.env.VUE_APP_SPA2_BASE_URL
    ffLogoAssetLink = require('../../../../assets/images/logo/logo_ff_large.mondrian.svg')
    ffLogoDarkAssetLink = require('../../../../assets/images/logo/logo_club_dark.mondrian.svg')

    switchableUniverses: HeaderSwitcherItem[] = [
        {
            app: 'pro',
            name: 'BS',
            label: 'Business Solutions',
            href: `${process.env.VUE_APP_PRO_BASE_URL}`,
            tagline: 'L’espace dédié aux entreprises et experts',
            logo: require('../../../../assets/images/logo/logo_bs.svg'),
        },
    ]

    mounted() {
        if (this.me) {
            this.buildSwitcher()
        }
    }

    @Watch('me')
    onWatchMe() {
        if (this.me) {
            this.buildSwitcher()
        }
    }

    buildSwitcher() {
        this.switchableUniverses.forEach(universe => {
            if (this.me.business_lines?.includes(universe.name)) {
                this.switcherJoined.push(universe)
            } else {
                this.switcherDiscover.push(universe)
            }
        })
    }

    closeDropdown() {
        this.showDropdown = false
    }
}
